var general_rtlignore_default = {
  "alignLeft": "ZXFvX",
  "textWrapNowrap": "Oriva",
  "alignRight": "nnofx",
  "alignCenter": "Bh0PO",
  "sizeFullWidth": "zneuh",
  "renderedInTable": "NY-ro",
  "sizeOriginal": "JdUBi",
  "sizeContent": "aRot2",
  "sizeSmall": "-C8s3",
  "sizeSmallCenter": "el2RF",
  "flex": "oMSNS"
};
export {
  general_rtlignore_default as default
};
//# sourceMappingURL=general.rtlignore-scss.js.map
